module.exports = __webpack_public_path__ + "static/screen-web-598e33c71eadc3f48325c95cd9838421.png";